export const questionsKk = [
  {
    q: 'Картаны қалай беремін?',
    a: 'Картаны ресімдегеннен кейін жеке кабинетіңіз ашылады. Онда алушының нөмірін енгізуге болады. Алушыға бірден картаның мәліметтері жазылған смс хабарлама жіберіледі.'
  },
  {
    q: 'Картаның қолданылу мерзімі қандай?',
    a: 'Жарамдылық мерзімі - картаның артқы жағында көрсетілген карта шығарылған сәттен бастап 12 ай (карта іске қосылған сәттен бастап емес).<br/><br/> Мерзімі өткеннен кейін картадағы ақша жоғалады.'
  },
  { q: 'Картаны толықтыруға бола ма?', a: 'Картаны толықтыруға болмайды.' },
  {
    q: 'Картаны қай дүкендерде қолдануға болады?',
    a: 'Картамен MEGA - да кез келген тауар мен қызметтің ақысын төлеуге болады.'
  },
  { q: 'Картадан қолма-қол ақша шешуге бола ма?', a: 'Картадан қолма-қол ақша шешуге болмайды.' },
  {
    q: 'Картаның цифрлық түрін ресімдесе бола ма?',
    a: 'Иә, картаны ресімдеу парақшасында картаның цифрлық түрін шығаруға болады.'
  },
  {
    q: 'Пластикалық карта қанша уақытта дайын болады?',
    a: 'Пластик бірден шығарылады. Сіз Mega-да пластикалық картаны шығара аласыз.'
  },
  {
    q: 'Пластикалық картаны қалай сыйлаймын?',
    a: 'Пластикалық картаны MEGA - дан сатып алуға болады. Алдымен ол сізге тіркеледі және оны соңғы алушыға тіркеуге болатын жеке кабинетте пайда болады.'
  },
  {
    q: 'Картамен тауар мен қызметтердің ақысын интернетте төлей аламын ба?',
    a: 'Жоқ. Картамен тек MEGA ОСО-дағы тауарлар мен қызметтердің ақысын төлеуге болады.'
  },
  {
    q: 'Карта теңгерімін қалай біле аламын?',
    a: 'Карта теңгерімін банк парақшасындағы жеке кабинетіңізде біле аласыз.'
  },
  {
    q: 'Картаны ұялы әмиянға қоса аламын ба?',
    a: 'Иә, картаны Apple Pay, Samsung Pay, Google Pay или Garmin Pay-ге қоса аласыз.'
  },
  {
    q: 'Картаның қолданылу мерзімі өтіп кетсе, ондағы ақша қайда кетеді?',
    a: 'Жұмсалмаған ақша жоғалады.'
  },
  {
    q: 'Тауарды қайтарсам, ақша картаға қайта аударыла ма?',
    a: 'Иә. Қайтару картаның жарамдылық мерзімі аяқталғанға дейін 14 күннен кешіктірілмей ресімделген жағдайда.'
  }
]
